<h2 mat-dialog-title>Confirmar Redirección</h2>
<mat-dialog-content>
  <p>¿Estás seguro de que quieres salir de esta página?</p>
  <p>Perderas el progreso que llevas.</p>
</mat-dialog-content>
<mat-dialog-actions class="w-100 d-flex justify-content-around">
  <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
  <button class="btn btn-primary"  (click)="confirmarSalida()">Salir</button>
</mat-dialog-actions>